module.exports = __webpack_public_path__ + "img/salon_thumbnail-400x300.b0f0c7d2.jpg";